import * as React from 'react'
import { Provider } from 'react-redux'
import store from '../../../../store'
import ElementsSelector from './elements_selector'

export default function ElementsSelectorApp(props) {
  return (
    <Provider store={store}>
      <ElementsSelector {...props} />
    </Provider>
  )
}
